import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useQuery, UseQueryOptions } from 'react-query'
import { reportError } from 'utils/error'
import { CardDismissal } from 'types'
import { sendToApi } from 'api/client'
import { useAuth } from 'hooks/UseAuth'
import { useCreateCardDismissal } from 'hooks/queries/useCreateCardDismissal'
import { useCallback } from 'react'

type Data = { is_dismissed: boolean }

export type Options = UseQueryOptions<Data>

export const useCardDismissal = (identifier: CardDismissal, options?: Options) => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const auth = useAuth()
  const { mutateAsync } = useCreateCardDismissal()

  const dismissCard = useCallback(() => {
    return mutateAsync(identifier)
  }, [identifier, mutateAsync])

  const query = useQuery<Data>(
    [currentWorkspaceId, 'cardDismissal', identifier],
    async () => {
      const res = await sendToApi(
        `/users/${auth?.id}/card_dismissals/is_dismissed?identifier=${identifier}&workspace_id=${currentWorkspaceId}`,
      )
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error('Error fetching card dismissal')
      }
      return res.data
    },
    {
      enabled: !!auth?.id,
      cacheTime: 60 * 1000 * 60,
      refetchOnWindowFocus: false,
      onError: reportError,
      initialData: { is_dismissed: Boolean(localStorage.getItem(`home_cta:${currentWorkspaceId}:${identifier}`)) },
      ...options,
    },
  )

  return {
    ...query,
    dismissCard,
  }
}
